import { Component, OnInit } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-good-or-bad-encoding',
  templateUrl: './good-or-bad-encoding.component.html',
  styleUrls: ['./good-or-bad-encoding.component.css']
})
export class GoodOrBadEncodingComponent extends GeneralExerciseComponent {

  counter = 0;
  level = 1;
  solution: boolean;
  clickedValue: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.isSolvedImageVisible = false;
    this.clickedValue = undefined;
  }

  checkSolution() {
    if (this.solution === this.clickedValue) {
      this.solution = undefined;
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.generateNextExercise(); }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.initValues();
    this.counter ++;
  }

  setClickedValue(isGood: boolean) {
    this.clickedValue = isGood;
    this.checkSolution();
  }

  setSolution(isGood: boolean) {
    this.solution = isGood;
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

  getMaxWidth() {
    if (this.level === 2) {
      return '46%';
    } else {
      return '38%';
    }
  }
}
